import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import useTheme from '@mui/styles/useTheme';
import { useTranslation } from 'react-i18next';
import ShippingDetailItemCard from './ShippingDetailItemCard';
import EtaItemCard from './EtaItemCard';

function ShippingDetailsSection({ detail, orderNumber, plantCode }) {
	const theme = useTheme();
	const { t } = useTranslation('order_details');

	return (
		<Grid
			container
			style={{
				marginTop: theme.spacing(-0.75),
				backgroundColor: theme.palette.base.light,
				borderTop: `1px solid ${theme.palette.divider}`,
				padding: `${theme.spacing(3)} ${theme.spacing(4)} ${theme.spacing(
					2.9
				)} ${theme.spacing(4)}`,
			}}
			aria-label={t('shipping_details')}
		>
			<Grid
				item
				xs={12}
				aria-label={t('shipping_details')}
				style={{ paddingBottom: theme.spacing(0.25) }}
			>
				<Typography aria-label={t('shipping_details')} role="paragraph">
					{t('shipping_details')}
				</Typography>
			</Grid>
			<Grid
				item
				xs={12}
				container
				columnSpacing={2}
				rowSpacing={2}
				style={{ marginTop: theme.spacing(-1.75) }}
			>
				<Grid item xs={6} sm={3} lg={2} aria-label={t('trailer_number')}>
					<ShippingDetailItemCard
						name={t('trailer_number')}
						value={detail.carrier_Equipment_Number}
					/>
				</Grid>
				<Grid item xs={6} sm={3} lg={2} aria-label={t('quantity_shipped')}>
					<ShippingDetailItemCard
						name={t('quantity_shipped')}
						value={detail.shipped_Quantity ? detail.shipped_Quantity : '-'}
					/>
				</Grid>
				<Grid item xs={6} sm={3} lg={2} aria-label={t('bol')}>
					<ShippingDetailItemCard
						name={t('bol')}
						value={detail.boL_Number ? detail.boL_Number : '-'}
					/>
				</Grid>
				<Grid item xs={6} sm={3} lg={2} aria-label={t('invoice_number')}>
					<ShippingDetailItemCard
						name={t('invoice_number')}
						value={
							detail.invoices && detail.invoices[0].number
								? detail.invoices[0].number
								: '-'
						}
					/>
				</Grid>
				{detail.tracking_Url !== null && (
					<Grid item xs={6} sm={3} lg={2} aria-label={t('eta')}>
						<EtaItemCard
							name={t('eta')}
							order={orderNumber}
							bol={detail.boL_Number}
							plant={plantCode}
						/>
					</Grid>
				)}
			</Grid>
		</Grid>
	);
}

ShippingDetailsSection.propTypes = {
	detail: PropTypes.object.isRequired,
	orderNumber: PropTypes.string,
	plantCode: PropTypes.string,
};

export default ShippingDetailsSection;
